import { useBucket } from '@mc/experiments-react'
import { PROMO_STICKY_FOOTER_FACE_STACK_FLAG_NAME } from '../constants'
import { useIsEligible } from './useIsEligible'

export const useShowFaceStack = () => {
  const isEligible = useIsEligible()
  const bucket = useBucket<'control' | 'variant_1'>(
    PROMO_STICKY_FOOTER_FACE_STACK_FLAG_NAME,
  )

  return isEligible && bucket === 'variant_1'
}
